/* eslint-disable import/no-relative-packages */
import { publish } from 'libs/pubsub';
import { observer } from 'mobx-react';
import { BrowserRouter, Routes } from 'react-router-dom';
import { StrictMode, useEffect, useState } from 'react';
import orgConfig from '../../../config';
import { getLayoutRoutes, renderRoutes } from './routes';
import { useStores, StoreProvider } from './stores';

import './global.scss?global';

// @ts-ignore
import { withAuthorization } from '@microcoreapps/authentication';
// @ts-ignore
import { Loading } from '@microui/react-ui';

function withProvider(C) {
  return function WrappedComponent(props) {
    return (
      <StoreProvider>
        <C {...props} />
      </StoreProvider>
    );
  };
}

export default withAuthorization(withProvider(observer(({
  layoutSubscriptionTopic, user, renewToken,
}) => {
  const { rootStore } = useStores();

  useEffect(() => {
    rootStore.set({
      sessionInfo: user,
      renewToken,
      layoutSubscriptionTopic
    });

    if (layoutSubscriptionTopic) {
      publish(`${layoutSubscriptionTopic}`, {
        type: 'single',
        routes: getLayoutRoutes(user?.profile),
      });
    }
  }, []);

  return (
    <div id="microauth-profile" className="bg-gray-900 w-full h-full">
      <StrictMode>
        <BrowserRouter basename={orgConfig.basename}>
          <Routes>
            {renderRoutes(rootStore?.sessionInfo?.profile)}
          </Routes>
        </BrowserRouter>
      </StrictMode>
    </div>
  );
})));
